import { NavGroup } from '@frameio/vapor';
import { useRecentProjects } from '@frameio/workspaces/shared';
import { ProjectRow } from './ProjectRow';
import type {
  MoveToCopyToProject,
  WorkspaceProjectSelectCallback,
} from './types';

type RecentProjectsProps = {
  label: string;
  onWorkspaceProjectSelect: WorkspaceProjectSelectCallback;
};

export function RecentProjects({
  label,
  onWorkspaceProjectSelect,
}: RecentProjectsProps) {
  const recentProjects = useRecentProjects();

  if (!recentProjects?.length) return null;

  return (
    <NavGroup label={label}>
      {recentProjects.map((project) =>
        project ? (
          <ProjectRow
            key={project.id}
            onSelect={() => {
              if (project.workspace) {
                onWorkspaceProjectSelect({
                  // Recent projects come from a different query that omits some
                  // fields (e.g. ignoreArchive); those fields are unused by the
                  // folder view, so a cast is safe here.
                  project: project as unknown as MoveToCopyToProject,
                  workspace: project.workspace,
                });
              }
            }}
            projectId={project.id}
          />
        ) : null
      )}
    </NavGroup>
  );
}
